import ApartmentService from '../../services/ApartmentService'
import BuildingService from '../../services/BuildingService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
const enums = require('../../helpers/Enums')

export const namespaced = true

const initialState = {
  apartments: [],
  selectedApartment: null,
  status: null
}

export const state = {
  apartments: [],
  selectedApartment: null,
  status: null
}

export const mutations = {
  SET_APARTMENTS(state, recs) {
    state.apartments = recs
  },
  SET_SELECTED_APARTMENT(state, rec) {
    state.selectedApartment = rec
  },
  SET_APARTMENT_VALUE(state, status) {
    state.status = status
  },
  RESET_STATUS_VALUE(state) {
    state.status = null
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchApartments: function(context, value) {
    return BuildingService.getApartmentsForBuilding(
      context.rootGetters['BuildingStore/getSelectedBuildingId']
    ).then(
      r => {
        context.commit('SET_APARTMENTS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_APARTMENTS', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedApartment: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ApartmentService.getApartmentById(value).then(
      r => {
        context.commit('SET_SELECTED_APARTMENT', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'APARTMENT ',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_APARTMENT', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  addApartment: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return ApartmentService.addApartment(value).then(
      context.dispatch('fetchApartments')
    )
  },
  updateApartment: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    return ApartmentService.updateApartment(value).then(
      res => {
        context.dispatch('fetchApartments')
        context.commit('SET_SELECTED_APARTMENT', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'APARTMENT ',
            name: res.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deleteApartment: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    try {
      return await ApartmentService.deleteApartment(value)
    } catch (error) {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(error, context, router)
      throw error
    }
  },
  setApartmentValue: function(context, value) {
    const apartmentStatus = enums.default.ApartmentStatus
    if (value === apartmentStatus.apartment_status_available) {
      value = 'available'
    }
    if (value === apartmentStatus.apartment_status_reserved) {
      value = 'reserved'
    }
    if (value === apartmentStatus.apartment_status_sold) {
      value = 'sold'
    }
    if (value === apartmentStatus.apartment_status_unavailable) {
      value = 'unavailable'
    }
    context.commit('SET_APARTMENT_VALUE', value)
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  },
  resetStatusValue: function(context) {
    context.commit('RESET_STATUS_VALUE')
  }
}

export const getters = {
  getSelectedApartmentId: state => {
    return state.selectedApartment ? state.selectedApartment.id : 0
  }
}
